<template>
    <div class="file-upload">
        <Upload
            v-if="uploadList.length <= 0"
            class="item"
            ref="upload"
            :before-upload="customerUpload"
            :action="uploadApi"
            :headers="uploadHeaders"
            :on-success="onUploadSuccess"
            :on-format-error="onUploadFormatError"
            :on-exceeded-size="onUploadSizeError"
            :accept="accept"
            :format="format"
            :max-size="4096"
            :show-upload-list="true"
            type="drag"
            :disabled="loading"
        >
            <!--            <slot name="desc"></slot>-->
            <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或将文件拖拽到这里上传</p>
                <p class="ex-desc">支持扩展名：{{ accept }}</p>
            </div>
        </Upload>
        <template v-else>
            <div class="file-upload-list" v-for="(item, index) in uploadList" :key="index">
                <template>
                    <div class="file-upload-item">
                        <a :href="item.url" target="_blank" class="file-link">
                            <Icon type="md-document" size="52" style="color: red" />
                            <i class="file-link-url">{{ item.name }}</i>
                        </a>
                        <p>
                            <Icon
                                type="ios-trash-outline"
                                style="cursor: pointer"
                                title="删除"
                                size="52"
                                @click.native="removeUploadItem(index)"
                            ></Icon>
                        </p>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
/** 文件上传组件 */
import util from '@/libs/util';
import axios from 'axios';

export default {
    props: {
        accept: {
            type: String,
            default: '.gif,.png,.jpg,.jpeg,image/png,image/jpg,image/jpeg',
        },
        format: {
            type: Array,
            default: () => {
                return ['jpg', 'jpeg', 'png'];
            },
        },
        maxlength: {
            type: Number,
            default: 5,
        },
        custom: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            uploadList: [],
            loading: false,
            activeImg: '',
            uploadApi: '/api/upload/fileUpload',
            uploadHeaders: {
                Authorization: util.cookies.get('token'),
                'supplier-domain': 'dt',
            },
        };
    },

    methods: {
        customerUpload(file) {
            // 是否是自定义上传，返回file文件
            if (this.custom) {
                this.uploadList.push(file);
                this.$emit('customFileUpload', file);
                return false;
            }
            console.log('拿到 file =====', file);
            let forms = new FormData();
            let name = file.name.split('.');
            forms.append('file', file, `${name[0]}.${new Date().getTime()}.${name[1]}`);
            let configs = {
                headers: {
                    Authorization: util.cookies.get('token'),
                    'supplier-domain': 'dt',
                },
            };
            let url = `/api/upload/fileUpload`;
            this.loading = true;
            this.$Message.loading({
                content: '上传中...',
                duration: 0,
            });
            axios
                .post(url, forms, configs)
                .then((res) => {
                    this.loading = false;
                    if (res.data.code === 200) {
                        file.url = res.data.data;
                        this.$Message.destroy();
                        this.$Message.success('上传成功');
                        this.uploadList.push(file);
                        console.log(this.uploadList);
                    } else {
                        this.$Message.destroy();
                        this.$Notice.error({
                            title: '上传失败',
                            desc: res.data.message,
                        });
                        this.$refs.upload.fileList.splice(this.$refs.upload.fileList.length - 1, 1);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$Message.destroy();
                    this.$Message.error('上传失败，请重试！');
                    console.log('网络错误');
                });
            return false;
        },

        removeUploadItem(i) {
            // console.log('删除 == ', i)
            this.uploadList.splice(i, 1);
        },
        onUploadSuccess(res, file) {
            if (res.code === 200) {
                file.url = res.data;
                this.$Message.success('上传成功');
                this.uploadList.push(file);
                console.log(this.uploadList);
            } else {
                this.$Notice.error({
                    title: '上传失败',
                    desc: res.message,
                });
                this.$refs.upload.fileList.splice(this.$refs.upload.fileList.length - 1, 1);
            }
        },
        onUploadFormatError() {
            this.$Notice.warning({
                title: '文件格式不正确',
                desc: `应为：${this.accept}`,
            });
        },
        onUploadSizeError(file) {
            this.$Notice.warning({
                title: '超出文件大小限制',
                desc: '文件 ' + file.name + ' 太大，不能超过 4M。',
            });
        },
    },
};
</script>
<style lang="less" scoped>
.ex-desc {
    padding: 0 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #808695;
    font-size: 13px;
    line-height: 28px;
}
.file-upload-item {
    width: 100%;
    height: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    flex-direction: column;
    align-items: center;
    &:hover {
        border-color: #ccc;
    }
}
.file-link {
    padding: 0px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .file-link-url {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
